module.exports = __webpack_public_path__ + "img/4fbc5caa699a66427638784f76009233.png";